export const WorkflowType = {
    MULTIPLE_TRANSFER_REQUEST: 'multiple transfer',
    TRANSFER_REQUEST: 'transfer',
    BULK_TRANSFER: 'bulk transfer',
    BILL_PAYMENT_REQUEST: 'bill payment',
    MULTIPLE_BILL_PAYMENT_REQUEST: 'multiple bill payment',
    PAYROLL_REQUEST: 'payroll',
    ON_DEMAND_REQUEST: 'on demand',
}